import Container from "react-bootstrap/Container";
import PageTitle from "../../../components/Elements/PageTitle/PageTitle.tsx";
import MyFormik from "../../../components/Form/MyFormik.tsx";
import { IconEdit } from "../../../components/Icon/Icon.tsx";
import { URLS } from "../../../routes.tsx";
import LienProfilFonctionnaliteForm, {
  getInitialValues,
  prepareValues,
  validationSchema,
} from "./LienProfilFonctionnaliteForm.tsx";

const GroupeFonctionnalitesCreate = () => {
  return (
    <Container>
      <PageTitle
        title="Création d'un lien profil / groupe de fonctionnalités"
        icon={<IconEdit />}
      />
      <MyFormik
        initialValues={getInitialValues()}
        prepareVariables={(values) => prepareValues(values)}
        validationSchema={validationSchema}
        submitUrl={`/api/lien-profil-fonctionnalite/create`}
        isPost={true}
        redirectUrl={URLS.LIEN_PROFIL_FONCTIONNALITE_LIST}
        onSubmit={() => true}
      >
        <LienProfilFonctionnaliteForm />
      </MyFormik>
    </Container>
  );
};

export default GroupeFonctionnalitesCreate;
